// extracted by mini-css-extract-plugin
export var cardIcon = "_8o-5";
export var checkboxCard = "_8o-0";
export var checkboxCardSelected = "_8o-4";
export var disabled = "_8o-2";
export var interactive = "_8o-1";
export var outerBorder = "_8o-3";
export var spacerMedium = "_8o-8";
export var spacerSmall = "_8o-7";
export var spacerXsmall = "_8o-6";